export enum InsightsViewType {
    NET_AMOUNTS = 'NET_AMOUNTS',
    TOTAL_AMOUNTS = 'TOTAL_AMOUNTS'
}
